import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function PhytaseHidosing(props) {
  return (
    <>
      <Row>
        <Col>
          <Table>
            <Header>
              <tr>
                <th style={{ width: "185px" }}>
                  <span></span>
                </th>
                <th>
                  <span>Qual tipo?</span>
                </th>
                <th>
                  <span>Qual Produto?</span>
                </th>
                <th>
                  <span>Qual dose?</span>
                </th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>Pré</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.pre.type"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.pre.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.pre.dose"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>Inicial</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.initial.type"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.initial.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.initial.dose"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.growth.type"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.growth.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.growth.dose"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>Desenvolvimento</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.development.type"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Tipo"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.development.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.phytaseHidosing.development.dose"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
            </Body>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          <label>Microtech está aprovada? Se não, por qual motivo?</label>
          <Input
            type="checkbox"
            params="enzymes.phytaseHidosing.approved.checked"
            item={props.megg}
            setItem={props.setMegg}
            label="Aprovado"
          />
          <Input
            type="input"
            label=" "
            params="enzymes.phytaseHidosing.approved.reason"
            item={props.megg}
            setItem={props.setMegg}
            disabled={props.megg.enzymes.phytaseHidosing.approved.checked}
            placeholder="Digite o motivo"
          />
        </Col>
      </Row>
    </>
  );
}
